export function svgAnimation() {
    window.addEventListener("DOMContentLoaded", function () {
        let svgContainer = $("[data-src-path]");
        let animationCollection = [];

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                let animationInstance = entry.target;

                if (entry.isIntersecting) {
                    animationCollection[animationInstance.dataset.id].play();
                } else {
                    animationCollection[animationInstance.dataset.id].pause();
                }
            });
        });

        svgContainer.each(function (index, item) {
            let instance = lottie.loadAnimation({
                container: item,
                renderer: "svg",
                autoplay: false,
                loop: true,
                path: item.dataset.srcPath
            });

            animationCollection.push(instance);

            item.dataset.id = index;

            observer.observe(item);
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/svgAnimation.js